// extracted by mini-css-extract-plugin
export var skipAnimation = "_p-0";